import { DragSource, DropTarget } from 'react-dnd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateSelectArea, updateSelectCard } from "Store/ZoneSetting/action";
import { getItemTypeCom } from './createCard';
import { removeSelectCardCls, queryOrgAuthority } from './events';
import { langCheck } from 'Pub/js/utils';
import Notice from "Components/Notice";
import _ from "lodash";
import MoveCardSelection from './components/MoveCardSelection';
import platform from "Pub/js/platform";
import { findMetaTreeIndex } from './methods/findMetaTreeIndex';
import { calculateBlankCardWidth } from './methods/calculateBlankCardWidth';
import { perceptionCheckboxShow } from './methods/card';

const { NCCheckbox } = platform.base;
const { PubSub } = platform;
//卡片属性组件类
const cardSource = {
    canDrag(props) {
        return !props.cardInfo.blank;
    },
    beginDrag(props) {
        return {
            id: props.id,
            index: props.index,
            areaIndex: props.areaIndex,
        };
    },
    isDragging(props, monitor) {
        // If your component gets unmounted while dragged
        // (like a card in Kanban board dragged between lists)
        // you can implement something like this to keep its
        // appearance dragged:
        return monitor.getItem().id === props.id;
    },
};

const cardTarget = {
    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }
    },
    drop(props, monitor, component) {
        const item = monitor.getItem();
        const dropIndex = props.index;
        item.areaIndex = item.metaTree ? findMetaTreeIndex(props.areaList, item.targetAreaID) : item.areaIndex;
        //props.setBlankDomWidth();
        if (item.notMetaData) {
            //实施态查询区不让拖非元数据
            if (props.isImplement && props.areatype === '0') {return;}
            props.openAddNotMetaInArea();
            props.setRealAreaIndexAndNotMetaData({
                currentNotMeta: {
                    datatype: item.datatype,
                    dropIndex,
                },
                realAreaIndex: props.areaIndex,
            });
            return;
        }

        props.areaIndex = props.groupBelongToFormAreaIndex ? props.groupBelongToFormAreaIndex : props.areaIndex;

        if (monitor.didDrop() || item.index === dropIndex || item.areaIndex !== props.areaIndex) {
            // If you want, you can check whether some nested
            // target already handled drop
            return;
        }

        if (item.metaTree) {
            // console.time('treeMove');

            props.addMetaItem({
                selectedTreeNode: item.selectedNodes,
                dataRef: item.dataRef,
                targetAreaID: props.cardInfo.areaid,
                dropIndex: props.index,
            });
            return { result: true };
        }

        if (item.index < dropIndex) {
            props.moveCard(item.index, dropIndex - 1, props.areaIndex);
        } else {
            props.moveCard(item.index, dropIndex, props.areaIndex);
        }
    },
};

@DropTarget('card', cardTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}))
@DragSource('card', cardSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
}))
class MyCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            radioSelectedValue: "", //单选框选中值
            passwordValue: "", //密码框值
            menuVisible: false, //是否显示菜单
            controlIconShow: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        let areaItem = this.props.areaItem;
        let nextAreaItem = nextProps.areaItem;
        if (nextAreaItem.queryPropertyList.length !== areaItem.queryPropertyList.length) {
            return true;
        }

        //选中卡片不渲染
        if (Object.keys(nextProps.selectCard).length > 0 && !_.isEqual(nextProps.selectCard, this.props.selectCard)) {
            return false;
        }
        //隐藏不显示属性渲染
        if (nextProps.shouldHideGray !== this.props.shouldHideGray) {
            return true;
        }
        //改变区域类型时渲染
        if (nextProps.areaItem.areatype !== this.props.areaItem.areatype) {
            return true;
        }
        //拖拽当前卡片不渲染其他区域卡片
        // 这里有个问题：放下后会阻止拖拽元素的isDragging变为false
        // if (_.isEqual(nextProps.areaItem.queryPropertyList, this.props.areaItem.queryPropertyList)
        // 	&& nextProps.areaItem.pk_area !== this.props.selectCard.areaid){
        // // if (_.isEqual(nextProps.areaItem.queryPropertyList, this.props.areaItem.queryPropertyList)){
        //     return false;
        // }
        return true;
    }

    componentWillUnmount() {
        this.cardDom = null;
    }

    //删除该卡片
    deleteCard = e => {
        e.stopPropagation();
        //2111新增：删除字段时需判断是否被其他字段依赖，如果是，则需要先解除依赖关系再删除
        //当前区域的所有字段
        let allAreaData = this.props.areaItem.formPropertyList.length !== 0
            ? this.props.areaItem.formPropertyList //表格表单区
            : (this.props.areaItem.queryPropertyList || '');//查询区
        //过滤出当前区域所有设置了参照过滤的字段
        let refFilterCardList = allAreaData.filter(item => item.refcondition !== undefined);
        //当前删除字段的code
        let deleteCardCode = this.props.cardInfo.code;
        //当前删除字段的name
        // let deleteCardName = this.props.name;

        //依赖当前字段的字段名称和编码
        let refConditionList = [];
        if (refFilterCardList.length !== 0) {
            refFilterCardList.map(item => {
                item.refcondition = _.isArray(item.refcondition) ? item.refcondition : JSON.parse(item.refcondition);
                item.refcondition.map(i => {
                    if (i.value == deleteCardCode) {
                        refConditionList.push({ name: item.label, code: item.code });
                    }
                });
            });
        }

        let thisCard = this.props.areaList[this.props.areaIndex].queryPropertyList[this.props.index];
        //实施态查询区勾选固定条件时不能删除字段
        if (this.props.isImplement && thisCard.isfixedcondition == true) {
            Notice({ status: "warning", msg: langCheck('ZoneSetting-000231', 'pages', this.props.json) }); /* 国际化处理： 勾选为固定条件不能删除*/
            //有依赖当前字段的字段refConditionlist时不能删除字段,需要先解除依赖关系
        } else if (refConditionList.length !== 0) {
            let refField = [];
            refConditionList.forEach(item => {
                refField.push(`${item.name}${item.code}`);
            });
            Notice({
                status: "warning",
                msg: `${refField.toString()}${langCheck("ZoneSetting-000348", "pages", this.props.json)}`,
            }); /* 国际化处理：***设置了该字段的参照过滤依赖，如需删除该字段，请先去掉依赖关系*/
        } else {
            this.props.deleteCard(this.props.index);
            this.setState({ menuVisible: false });
        }
    };
    //选择该卡片
    selectThisCard = e => {
        e.stopPropagation();
        if (this.props.cardInfo.blank) {
            return false;
        }
        this.updateThisCard(e);
        if (!_.isEmpty(this.props.selectedArea)) {this.props.updateSelectArea({});} //选中卡片时清空选中区域

        let { areaList, areaIndex, index } = this.props;
        let card = areaList[areaIndex].queryPropertyList[index];
        //如果卡片为参照类型，根据请求结果判断是否显示
        if (card.datatype === '204' && card.refname) {
            queryOrgAuthority.call(this, card.refname, res => PubSub.publish('SELECT_CARD', res));
            //如果卡片不是参照类型,直接不显示组织权限字段
        } else {
            PubSub.publish('SELECT_CARD', false);
        }
    };

    //更新所选卡片数据
    updateThisCard = e => {
        let { areaList, areaIndex, index } = this.props;
        let card = areaList[areaIndex].queryPropertyList[index];
        this.updateActiveCardCls();
        this.props.updateSelectCard(card);
    };

    //更新选中卡片className
    updateActiveCardCls = () => {
        removeSelectCardCls();
        this.cardDom && this.cardDom.classList.add("select-card");
    }

    //获得卡片样式的className名
    getCardClassName = () => {
        const { selectCard, required, id, areaid, cardInfo, isOver, areaType } = this.props;
        const hoverCls = isOver ? ' hover' : '';
        const searchAreaCls = areaType === 'search' ? 'search-card' : '';
        const disabledCls = cardInfo.disabled == true ? ' disabled-card' : '';//加disabled的class目的是为了解决火狐下disabled的字段onClick事件失效
        let result = '';
        if (required) {
            result = ' required-card';
        }
        if (selectCard.pk_query_property === id && selectCard.areaid === areaid) {
            result = `select-card${result}`;
        } else {
            result = `normal-card${result}`;
        }

        return `${result}${hoverCls}${disabledCls} ${searchAreaCls}`;
    };

    perceptionMenuVisible = e => {
        setTimeout(() => {
            let menuDom = this.cardDom && this.cardDom.querySelector('.move-card-selection');

            if (menuDom) {
                menuDom.clientWidth === 0 &&
                    this.state.menuVisible === true &&
                    this.setState({ menuVisible: false });
            }
        }, 100);
    };

    toggleMenuVisible = e => {
        e && e.stopPropagation();
        this.setState({ menuVisible: !this.state.menuVisible });
    };

    handleIconShow = boolean => {
        this.setState({ controlIconShow: boolean });
    };

    handleCheckCard = value => {
        let { cardInfo } = this.props;
        this.props.handleCheckCard(value, cardInfo);
    };

    //判断是否显示输入项
    showItemTypeCom = () => {
        let { showCardCheckboxController, areaType, cardInfo } = this.props;

        if (areaType === 'search') {
            return true;
        }

        return !showCardCheckboxController[cardInfo.areaid];
    };

    //渲染卡片字段
    renderCard = ({ opacity, showName }) => {
        const { areaType, color, cardInfo, visible, selectCard, isOver, json, areaList, isDragging } = this.props;
        const cardCls = this.getCardClassName();
        const prefix = areaType !== 'table' ? 'card' : areaType;
        const cardProps = { ...cardInfo, onClick: this.selectThisCard };
        let tableColWidth = {};
        let code = String(cardInfo.code).replace(/\.|\&|\#/g, '');
        let cardCheckboxClass = this.props.showCardCheckboxController[cardInfo.areaid] && 'card-checkbox';
        //根据组件长度改变表格区列宽度
        if (areaType === 'table' && !isNaN(cardInfo.width)) {
            if (+cardInfo.width > 120 && !this.props.areaItem.isTile) {
                tableColWidth.minWidth = +cardInfo.width;
            }
        }
        let controlIconShowClass = this.state.controlIconShow ? 'control-icon-show' : '';
        let isBlankDom = cardInfo.blank ? 'is-blank-dom' : '';
        let cardList = areaList[this.props.areaIndex].queryPropertyList;
        return (
            <li
                className={`property-item ${prefix}-content ${cardCls} search-unit-${code} ${controlIconShowClass} ${cardCheckboxClass} ${isBlankDom}`}
                fieldid={cardInfo.code} //自动化测试标记
                onClick={this.selectThisCard}
                onMouseLeave={this.perceptionMenuVisible}
                ref={dom => this.cardDom = dom}
                style={{ minWidth: calculateBlankCardWidth(cardInfo, cardList, areaType, this.cardDom, isDragging) }}
            >
                {
                    cardInfo.blank !== true && (
                        <div className={`${prefix}-item`} title={showName} style={{ color, ...tableColWidth }}>
                            {
                                areaType !== 'search' &&
                                <div className="item-name" style={{color}}>
                                    <span className="title search-unit-label">{showName}</span>
                                </div>
                            }

                            {
                                this.showItemTypeCom() && <div
                                    className="item-content">{getItemTypeCom.call(this, cardProps, areaType, json, showName)}</div>}
                            <MoveCardSelection
                                className={`card-menu-${code}`}
                                visible={this.state.menuVisible}
                                toggleMenuVisible={this.toggleMenuVisible}
                                handleIconShow={this.handleIconShow}
                                cardDom={this.cardDom}
                                index={this.props.index}
                                addMetaItem={this.props.addMetaItem}
                                setCardCheckboxState={this.props.setCardCheckboxState}
                                checkAllCard={this.props.checkAllCard}
                                showCardCheckboxController={this.props.showCardCheckboxController}
                                clearCheckedCard={this.props.clearCheckedCard}
                                revertThisAction={this.props.revertThisAction}
                                batchMoveCard={this.props.batchMoveCard}
                                cardInfo={cardInfo}
                                handleCheckCard={this.handleCheckCard}
                                json={this.props.json}
                            />
                            <span className='delete-card' onClick={this.deleteCard}> x </span>
                            {!visible && <span className="hidden-tag"></span>}

                            {
                                perceptionCheckboxShow(this.props) &&
                                <div className='card-checkbox-container'>
                                    <NCCheckbox
                                        checked={this.props.checkedCards[cardInfo.areaid].includes(cardInfo.code)}
                                        onChange={this.handleCheckCard}
                                    />
                                </div>
                            }

                        </div>
                    )
                }
            </li>
        );
    }

    render() {
        const {
            name,
            visible,
            shouldHideGray,
            isDragging,
            connectDragSource,
            connectDropTarget,
        } = this.props;
        // console.log('render card');
        // const opacity = visible ? 1 : 0.5;
        const opacity = isDragging ? 0.3 : visible ? 1 : 0.6;
        const showName = _.isEmpty(name) ? String.fromCharCode(160) : name;
        if (shouldHideGray === true && visible === false) {
            return null;
        }
        return connectDragSource(
            connectDropTarget(this.renderCard({ opacity, showName })),
        );
    }
}
export default connect(
    state => ({
        selectCard: state.zoneSettingData.selectCard,
        selectedArea: state.zoneSettingData.selectedArea,
        areaList: state.zoneSettingData.areaList,
        isImplement: state.zoneSettingData.isImplement,
    }),
    {
        updateSelectArea,
        updateSelectCard,
    },
)(MyCard);
